<template>
    <div>
        <TransitionGroup v-bind:name="animationName">
            <div v-bind:key="currentItem.level" class="menu__slide">
                <div class="menu__slide-inner">
                    <!--<a v-bind:href="context.root" class="sidebar-logo">
                        <div class="sidebar-logo__icon" role="img" aria-label="Tasa-arvoinen varhaiskasvatus">
                          (logo)
                        </div>
                    </a>-->
                    <!--<form class="sidebar-search" action="/" v-on:submit="doSearch" method="get">
                        <input type="text"
                               name="s"
                               v-bind:placeholder="context.i18n.search"
                               aria-label="Hakusana"
                        >
                        <button type="submit" class="sidebar-search__button" aria-label="Hae">
                          <span class="sidebar-seach__svg-wrapper" v-if="!searching">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g fill="none" fill-rule="evenodd" transform="translate(1 1)"><path fill="#545556" d="m16.7 15.3-4.67-4.7a6.66 6.66 0 1 0-1.41 1.43l4.67 4.69a1.03 1.03 0 0 0 1.42 0c.2-.2.29-.45.29-.7a1 1 0 0 0-.3-.73ZM2 6.66a4.67 4.67 0 1 1 9.35 0 4.67 4.67 0 0 1-9.35 0Z"></path><circle cx="6.5" cy="6.5" r="4.5"></circle></g></svg>
                          </span>
                          <span class="sidebar-seach__svg-wrapper svg-wrapper--spinner" v-if="searching">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g fill="none" fill-rule="evenodd" stroke="#545556" stroke-width="2"><circle cx="10" cy="10" r="7" opacity=".25"></circle><path stroke-linecap="round" d="M17 10a6.98 6.98 0 0 0-7-7c-1.3 0-2.5.35-3.54.96"></path></g></svg>
                          </span>
                        </button>
                    </form>-->
                    <button class="sidebar-item sidebar-item--back-button"
                            v-if="currentItem.level > 0"
                            v-on:click="goBack"
                    >
                        <span class="sidebar-item__arrow-back">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M1.37 7.57h11.89M9.17 2l5.29 5.57-5.29 5.57"/></g></svg>
                        </span>
                        {{ getBackText(currentItem) }}
                    </button>

                    <a class="sidebar-item"
                       v-if="currentItem.children.length && currentItem.level !== 0"
                       v-bind:href="currentItem.url"
                       v-bind:class="{'sidebar-item--active': (currentItem.url === context.current_item || currentItem.active === true)}"
                    >
                        <span class="sidebar-item__text" v-bind:class="{'sidebar-item__text--has-badge': currentItem.new}" v-html="currentItem.name"></span>
                    </a>

                    <div v-for="item in currentItem.children">
                        <a class="sidebar-item"
                           v-if="!item.children.length && !item.soon && !item.is_language_menu"
                           v-bind:href="item.url"
                           v-bind:class="{'sidebar-item--active': (item.url === context.current_item || item.active === true)}"
                        >
                            <span class="sidebar-item__text" v-bind:class="{'sidebar-item__text--has-badge': item.new}" v-html="item.name"></span>
                        </a>
                        <button class="sidebar-item" v-if="item.children.length && !item.soon && !item.is_language_menu" v-on:click="changeLevel(item)">
                            <span class="sidebar-item__text" v-html="item.name"></span>

                            <span class="sidebar-item__arrow-icon">

<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M1.37 7.57h11.89M9.17 2l5.29 5.57-5.29 5.57"/></g></svg>

                            </span>

                        </button>
                    </div>

                  <div class="sidebar-footer">
                    <ul class="sidebar-footer-inner">
                      <!--<li v-for="item in context.language_items">
                        <a v-bind:href="item.url">
                          <span class="capsize-inter">{{item.name}}</span>
                        </a>
                      </li>-->
                    </ul>
                  </div>

                </div>
            </div>
        </TransitionGroup>
    </div>
</template>

<script>
import * as deepdash from "deepdash/standalone";

export default {
    props: ['context'],
    data: function () {
        return {
            items: [],
            currentItem: null,
            animationName: null,
          searching: false,
        }
    },
    created() {
        function fixItem(item, level, parent) {
            const node = {
                ...item,
                level,
                parent,
            }
            if (item.children)
                node.children = item.children.map(child => fixItem(child, level + 1, node));
            return node;
        }

        this.items = {level: 0};
        this.items.children = this.context.items.map(item => fixItem(item, 1, this.items));

        function findNode(id, currentNode) {

            if (id === currentNode.url) {
                return currentNode;
            } else if (currentNode.children) {
                for (let i = 0; i < currentNode.children.length; i++) {
                    const result = findNode(id, currentNode.children[i]);
                    if (result && result.is_language !== true) {
                        return result;
                    }
                }

                // The node has not been found and we have no more options
                return false;
            }
        }

        const foundNode = findNode(this.context.current_item, this.items);

        if (foundNode.current && foundNode.children.length) {
            this.currentItem = foundNode ? foundNode : this.items;
        } else {
            this.currentItem = foundNode ? foundNode.parent : this.items;
        }




    },
    mounted() {

    },
    methods: {
      doSearch(event) {
        event.preventDefault();
        this.searching = true;
        event.currentTarget.submit();
      },
        changeLevel(item) {
            this.currentItem = item;
            this.animationName = 'menu';
            setTimeout( () => {
              document.querySelector('.sidebar-item').focus();
            }, 600)
        },
        goBack() {
            this.currentItem = this.currentItem.parent;
            this.animationName = 'menu-reverse';
          setTimeout( () => {
            document.querySelector('.sidebar-item').focus();
          }, 600)
        },
        getBackText(item) {
            if (item.parent.level > 0) {
              return item.parent.name;
            }
            return this.context.i18n.back;
        }
    }
}
</script>
